module.exports = __webpack_public_path__ + "media/images/icon_toggle_down-301f1e5daf75b381216e7a1e249bf16d.png";